import {
  ArrowRight,
  BookmarkSimple,
  ClockClockwise,
  ClockCounterClockwise,
  Headphones,
  Moon,
  Play,
  PlayCircle,
  SpeakerHigh,
  Sparkle,
  Sun,
  X,
} from '@phosphor-icons/react';

export const ICON_MAP = {
  'arrow-right': ArrowRight,
  'bookmark-simple': BookmarkSimple,
  'clock-clockwise': ClockClockwise,
  'clock-counter-clockwise': ClockCounterClockwise,
  headphones: Headphones,
  moon: Moon,
  play: Play,
  'play-circle': PlayCircle,
  'speaker-high': SpeakerHigh,
  sparkle: Sparkle,
  sun: Sun,
  x: X,
};

export type IconName = keyof typeof ICON_MAP;

export type IconWeight = 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone';
